import React from 'react'
import BePartner from '../Home/BePartner'

const BePartnerPage = () => {
  return (
    <>
      <BePartner/>
    </>
  )
}

export default BePartnerPage